import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setcurrentLeadID, setCurrentPageTitle } from '../../../../store/slices/pageSlice';
import { clearWizardState, goNext, goToStep } from '../../../../store/slices/WizardSlice/wizardStepSlice';
import useMatchedProject from '../useMatchedProject';
import useMatchedOperationsData from '../useMatchedOperationsData';
import { useCurrencySymbol } from '../../../../utils/currencyUtils';
import DateConversion from '../../../../utils/DateConversion';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import { updateAllProjectDueDatesByQuotationId } from '../../../../store/slices/projectDueDateSlice';
import ProjectApprovedSubWizard from './ProjectApprovedSubWizard';
import { fetchEmployees } from '../../../../store/slices/employeeSlice';
import useProjectApproved from './useProjectApproved';
import AdminLoader from '../../../../components/common/loader/AdminLoader';
import { useNavigate } from 'react-router-dom';
import { fetchLeads } from '../../../../store/slices/leadsSlice';
import { fetchGroups } from '../../../../store/slices/groupSlice';

const ProjectApprovedWizardDash = () => {
  const dispatch = useDispatch();
  const createdProject = useSelector((state) => state.wizardstep.createdProject);
  const operationProjectStatus = useSelector((state) => state.wizardstep.operationProjectStatus);
  const wizardPlanState = useSelector((state) => state.wizardstep.wizardPlanState);
  const wizardProjectState = useSelector((state) => state.wizardstep.wizardProjectState);
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
  const currency = useCurrencySymbol();
  const navigate = useNavigate()
  const operationProjectName = createdProject[0]?.ProjectName
  const { matchedApprovedProject,
    projectsApprovedSales } = useProjectApproved(operationProjectName)

  console.log("createdProject in approved", createdProject)
  const { matchedProject } = useMatchedProject(operationProjectName);
  const { employees } = useSelector((state) => state.employees);
  const { leads } = useSelector((state) => state.leads);
  const { group: groups } = useSelector((state) => state.group);


  const calculatedProjectData = useMatchedOperationsData(
    matchedProject[0]?.Projects || []
  );
  console.log("useSelector1 calculatedProjectData", calculatedProjectData)
  console.log("useSelector1 operationProjectStatus", operationProjectStatus)
  console.log("projectsApprovedSales", projectsApprovedSales)
  console.log("projectsApprovedSales operationProjectName", operationProjectName)
  console.log("projectsApprovedSales matchedApprovedProject", matchedApprovedProject)

  useEffect(() => {
    dispatch(setCurrentPageTitle("Project Approved"));
    dispatch(fetchEmployees());
    dispatch(fetchLeads());
    dispatch(fetchGroups());
  }, [dispatch]);

  const groupNameById = React.useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = React.useCallback((item) => {
    const groupId = item?.groupid?._id || item?.groupid;
    if (groupId && groupNameById.has(String(groupId))) {
      return groupNameById.get(String(groupId));
    }
    return item?.AssignedGroup || "";
  }, [groupNameById]);

  const [rowid, setrowid] = useState(null);
  const [selected, setSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mergedData, setMergedData] = useState([]);
  const [rowData, setRowData] = useState([]);
  console.log("projectsApprovedSales mergedData", mergedData)

  useEffect(() => {
    const filteredData = matchedApprovedProject?.filter(item => {
      // If projects array is empty, include the item
      if (!item?.projects || item?.projects?.length === 0) {
        return true;
      }

      // If projects array has items, check all assigned persons in all projects
      return item?.projects.every(project => {
        // Check if project has assigned persons
        if (!project.Assignedperson || project.Assignedperson.length === 0) {
          return false; // No assigned persons, exclude this item
        }

        // Check if ALL assigned persons have salespersonstatus as "project approved"
        return project.Assignedperson.some(person =>
          person.salespersonstatus === "project approved"
        );
      });
    });

    // const updatedDate = filteredData.map((item) => (
    //     item.projecttracktaskStatus === "submit" || item.projecttracktaskStatus === "pending"
    // ))
    // const updatedProjects = filteredData?.map(item => {
    //   const leadDate = new Date(item?.LeadDate);
    //   // Add 7 days (7 * 24 hours * 60 min * 60 sec * 1000 ms)
    //   const dueDate = new Date(leadDate?.getTime() + 7 * 24 * 60 * 60 * 1000);
    //   return {
    //     ...item,
    //     DueDate: dueDate?.toISOString(),   // or dueDate if you want Date object
    //   };
    // });

    setMergedData(filteredData);
  }, [matchedApprovedProject]);

  const handleDueDateChange = async (row, date, projectName, quotationId) => {
    if (!date || !projectName) return;

    if (row?.projects && row?.projects.length > 0) {
      setIsLoading(true);
      try {
        await dispatch(updateAllProjectDueDatesByQuotationId({
          quotationId: quotationId || projectName,
          ProjectDueDate: date,
        }));
      } catch (error) {
        console.error("Failed to update due date:", error);
        // Optional: Show error message
        // enqueueSnackbar("Failed to update due date", { variant: "error" });
      } finally {
        setIsLoading(false);
        dispatch(fetchLeads());
      }

    } else {
      setRowData(prevData => {
        // Check if project already exists in rowData
        const existingIndex = prevData.findIndex(item => item.projectName === projectName);

        if (existingIndex >= 0) {
          // Update existing project
          return prevData.map((item, index) =>
            index === existingIndex
              ? { ...item, ProjectDueDate: date }
              : item
          );
        } else {
          // Add new project
          return [
            ...prevData,
            {
              projectName: projectName,
              ProjectDueDate: date,
            }
          ];
        }
      });
    }
  };

  const ProjectApprovedref = useRef(null);
  useEffect(() => {
    if ((rowid)) {
      // Scroll to the right end of the container
      const scrollToPosition = ProjectApprovedref.current.scrollWidth;
      ProjectApprovedref.current.scrollTo({
        left: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }, [rowid]);

  return (
    <div>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}

      <div
        ref={ProjectApprovedref}
        className="w-[99%] min-h-[15rem] max-h-[90vh] overflow-auto bg-white  h-full justify-center pb-5">
        <div className="z-[50] sticky top-0 w-full">
          <div className="flex  text-xs bg-[#E8E8E8]  text-center text-black">
            <div className={`font-semibold ${rowid ? "" : "w-[80%]"}`}>
              <div className={` flex`}>
                <div className="w-14 bg-[#E8E8E8]  h-12 flex justify-center align-middle items-center">Sr. No</div>
                <div className={` ${rowid ? "w-24" : "w-[20%]"} h-12  bg-[#E8E8E8] p-2 break-words text-wrap flex justify-start align-middle items-center `}>
                  <spna className="pl-4">Group</spna>
                </div>
                <div className={`${rowid ? "w-28" : "w-[20%]"}  h-12 bg-[#E8E8E8] p-2 break-words text-wrap flex justify-start align-middle items-center`}>
                  Client Name
                </div>
                <div className={`${rowid ? "w-28" : "w-[20%]"}  h-12 bg-[#E8E8E8] p-2 break-words text-wrap flex justify-start align-middle items-center`}>
                  Project Name
                </div>
                <div className={`${rowid ? "w-28" : "w-[20%]"}  h-12 bg-[#E8E8E8] py-2 break-words text-wrap flex justify-center align-middle items-center`}>
                  Date  {rowid && <br />} Requested
                </div>
                <div className={`${rowid ? "w-28" : "w-[20%]"} h-12 bg-[#E8E8E8] p-2 break-words text-wrap flex justify-center align-middle items-center`}>
                  Due Date
                </div>

              </div>
            </div>
            {rowid ? (
              <div>
                <div className='flex font-semibold'>
                  <div className="w-36 border h-12 p-2 py-4 break-words text-wrap flex justify-center align-middle items-center bg-[#E8E8E8] ">
                    Assign To Managers
                  </div>
                  <div className="w-80 h-12 break-words text-wrap flex flex-col justify-center align-middle items-center bg-[#E8E8E8] ">
                    <div className="w-full p-2 h-[50%] break-words text-wrap flex justify-center items-center" >
                      Task Details
                    </div>
                    <div className="w-full h-[50%] break-words text-wrap flex ">
                      <div className="w-[33%] p-2  flex justify-center items-center">
                        Resources
                      </div>
                      <div className="w-[33%] p-2 flex justify-center items-center">
                        Hours/Parts
                      </div>
                      <div className="w-[34%] p-2 flex justify-center items-center">
                        Expenses ({currency})
                      </div>
                    </div>
                  </div>
                  <div className="w-32 border h-12 p-2 py-4 break-words text-wrap flex justify-center align-middle items-center bg-[#E8E8E8] ">
                    Action
                  </div>
                </div>
              </div>

            ) : (
              <div className='flex font-semibold w-[20%] h-12 border-t border-white justify-center align-middle items-center bg-[#E8E8E8] '>
                <h3> Input Details</h3>

              </div>
            )}


          </div>
        </div>

        <div className="w-full">
          {mergedData?.length > 0 ? (
            mergedData?.map((row, index) => {
              const matchedLead = leads?.find((proj) => proj?.ProjectName === row?.ProjectName)
              return (
                <div
                  className={`flex text-xs w-full ${matchedLead?.isRead === false ? "font-bold" : ""}  hover:bg-gray-100  group`}
                  key={index}
                >
                  <div className={` flex ${rowid ? "" : "w-[80%]"} `}>
                    <div
                      onClick={() => {
                        setrowid(prev => prev === row?.ProjectName ? null : row?.ProjectName)
                        setSelected(!selected)
                      }}

                      className="w-14 border-b text-black cursor-pointer flex justify-start align-middle items-center pl-2">
                      {index + 1}
                    </div>
                    <div onClick={() => {
                      setrowid(prev => prev === row?.ProjectName ? null : row?.ProjectName)
                      setSelected(!selected)
                    }}
                      className={`${rowid ? "w-24" : "w-[20%]"} border-b cursor-pointer  flex justify-start align-middle items-center p-2 break-words text-wrap`}>
                      <spna className="pl-4">{getDisplayGroupName(row)}</spna>
                    </div>
                    <div onClick={() => {
                      setrowid(prev => prev === row?.ProjectName ? null : row?.ProjectName)
                      setSelected(!selected)
                    }}
                      className={`${rowid ? "w-28" : "w-[20%]"} capitalize border-b cursor-pointer  flex justify-start align-middle items-center text-center p-2 break-words text-wrap overflow-hidden text-ellipsis line-clamp-2 break-all leading-snug text-xs`}>
                      {createdProject?.[0]?.ClientName}
                    </div>
                    <div onClick={() => {
                      setrowid(prev => prev === row?.ProjectName ? null : row?.ProjectName)
                      setSelected(!selected)
                    }}
                      className={`${rowid ? "w-28" : "w-[20%]"} border-b cursor-pointer  flex justify-start align-middle items-center text-center p-2 break-words text-wrap overflow-hidden text-ellipsis line-clamp-2 break-all leading-snug text-xs`}>
                     <span className=''> {row?.ProjectName}</span>
                    </div>
                    <div onClick={() => {
                      setrowid(prev => prev === row?.ProjectName ? null : row?.ProjectName)
                      setSelected(!selected)
                    }}
                      className={`${rowid ? "w-28" : "w-[20%]"} border-b cursor-pointer  flex justify-center align-middle items-center p-2 break-words text-wrap`}>
                      {row?.LeadDate && !isNaN(new Date(row?.LeadDate))
                        ? formatDateByCountry(row?.LeadDate)
                        : " "}
                    </div>
                    <div className={`${rowid ? "w-28" : "w-[20%]"} border-b p-2 cursor-pointer  flex justify-center align-middle items-center break-words text-wrap`}>
                      {!row?.projects?.some(project => project?.oldprojectid) ? (
                        <div className="w-[80%] ">
                          {(() => {
                            // ✅ Find matching project in rowData by project name
                            const matchingRowData = rowData?.find(
                              (data) => data?.projectName === row?.ProjectName
                            );
                            // ✅ Determine the selected date (priority order)
                            const selectedDate =
                              matchingRowData?.ProjectDueDate
                                ? new Date(matchingRowData?.ProjectDueDate)
                                : row?.projects[0]?.ProjectDueDate
                                  ? new Date(row?.projects[0]?.ProjectDueDate)
                                  : row?.ProjectDueDate
                                    ? new Date(row?.ProjectDueDate)
                                    : null;

                            return (
                              <DatePicker
                                selected={selectedDate}
                                onChange={(date) =>
                                  handleDueDateChange(row, date, row?.ProjectName, row?.quotationId)
                                }
                                dateFormat={getDateFormat()}
                                className="ProjectDueDateSelector w-full text-center outline-none border border-gray-300 px-2 py-1 rounded-md bg-white"
                                placeholderText={getDatePlaceholder()}
                                popperClassName="z-[1500]"
                                minDate={new Date()} // disable past dates
                              />
                            );
                          })()}
                        </div>
                      ) : (
                        // Show due date as plain text if any project has oldprojectid
                        <div className="text-center ">
                          {(() => {
                            const matchingRowData = rowData?.find(
                              (data) => data?.projectName === row?.ProjectName
                            );

                            const displayDate =
                              matchingRowData?.ProjectDueDate
                                ? new Date(matchingRowData?.ProjectDueDate)
                                : row?.projects[0]?.ProjectDueDate
                                  ? new Date(row?.projects[0]?.ProjectDueDate)
                                  : row?.ProjectDueDate
                                    ? new Date(row?.ProjectDueDate)
                                    : null;

                            return displayDate
                              ? formatDateByCountry(displayDate)
                              : " ";
                          })()}
                        </div>
                      )}
                    </div>

                    {/* <div className={`${rowid ? "w-28" : "w-[20%]"} border cursor-pointer  p-2 text-center flex justify-center align-middle items-center break-words text-wrap`}>
                    <AttachFileIcon
                      className=" rotate-12 cursor-pointer"
                      onClick={() => {
                        securrentProject(row)
                      }}
                    />
                  </div> */}
                  </div>

                  {rowid === row?.ProjectName ? (
                    <div className={`flex flex-col group-hover:bg-gray-100`}>
                      <ProjectApprovedSubWizard
                        rowData={rowData}
                        row={row}
                        employees={employees}
                        setIsLoading={setIsLoading}
                      />
                    </div>

                  ) : (
                    <div
                      onClick={() => {
                        setrowid(prev => prev === row?.ProjectName ? null : row?.ProjectName)
                        setSelected(!selected)
                      }}
                      className={` ${rowid ? "w-full" : "w-[20%]"} border-b cursor-pointer  flex justify-center align-middle items-center`}>

                      {rowid ? (
                        <div className='flex group-hover:bg-gray-100 '>
                          <div className="w-36 border-b p-2 py-4 ">
                          </div>
                          <div className="w-80 border-b p-2 py-4 break-words text-wrap flex justify-center align-middle items-center ">
                            Multiple
                          </div>
                          <div className="w-32 border-b p-2 py-4 ">

                          </div>
                        </div>
                      ) : (
                        <div>
                          Multiple
                        </div>

                      )}
                    </div>
                  )}

                </div>
              )
            })
          ) : (
            <div className="flex justify-center items-center p-8 text-gray-500">
              {"No data available."}
            </div>
          )}
        </div>
      </div>

      <div className='w-[99%] flex justify-end'>
        <div className="flex gap-4 pt-2">
          <button
            onClick={() => dispatch(goToStep(1))}
            // onClick={() => dispatch(goBack())}
            className=" py-2 px-7 bg-black overflow-hidden shadow-md text-white rounded-lg"
          >
            Back
          </button>
          <button
            onClick={() => {
              if (wizardPlanState === "advancedplan" && wizardProjectState === "existingProject") {
                navigate("/dashboard");
                dispatch(clearWizardState())
                dispatch(setcurrentLeadID())
              } else {
                dispatch(goNext())
              }
            }}

            className=" py-2 px-7 bg-[#e32278] overflow-hidden shadow-md text-white rounded-lg"
          >
            {wizardPlanState === "advancedplan" && wizardProjectState === "existingProject" ? "Save" : "Next"}
          </button>

        </div>
      </div>

    </div>
  )
}

export default ProjectApprovedWizardDash
